<template>
  <el-input :value="value" :disabled="disabled" @input="onInput" />
</template>

<script>
import { validEnglishWords } from '@/utils/validate'

export default {
  name: 'CargoEnglishWordsInput',
  props: {
    value: { type: [String, Number], required: true },
    autoUppercase: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {}
  },
  methods: {
    onInput(val) {
      if (this.autoUppercase && typeof val === 'string') {
        val = val.toUpperCase()
      }
      const validateReg = /[^\x00-\xff]/g // GBK 中文  一个用16进制指定的字符(占一个字节)
      const check = validEnglishWords(val)
      if (check) {
        this.$message.info(this.$t('Message.PleaseEnterEnglish'))
      }
      val = val.replace(validateReg, '')
      this.$emit('input', val)
    }
  }
}
</script>

<style>
</style>
